module.exports = __webpack_public_path__ + "img/linked_in.af782376.svg";